import { BaseFilterParams } from 'dashboard/lib/interfaces/BaseFilterParams';
import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import {
  GraphQueryTemplate,
  GraphQueryTemplateStatus,
} from 'dashboard/models/graph-query-template';
import Action from 'lib/interfaces/Action';

export type GraphQueryTemplateAction =
  | Action<GraphQueryTemplatesActionType.SetCurrentPage, SetCurrentPagePayload>
  | Action<GraphQueryTemplatesActionType.SetFilters, SetFiltersPayload>
  | Action<GraphQueryTemplatesActionType.SetGraphQueryTemplates, SetGraphQueryTemplatesPayload>
  | Action<GraphQueryTemplatesActionType.SetPageSize, SetPageSizePayload>
  | Action<GraphQueryTemplatesActionType.SetSortParams, SetSortParamsPayload>;

export enum GraphQueryTemplatesActionType {
  SetCurrentPage = 'graph-query-templates/SET_CURRENT_PAGE',
  SetGraphQueryTemplates = 'graph/SET_GRAPH_QUERY_TEMPLATES',
  SetPageSize = 'graph-query-templates/SET_PAGE_SIZE',
  SetSortParams = 'graph-query-templates/SET_SORT_PARAMS',
  SetFilters = 'graph-query-templates/SET_FILTERS',
}

interface SetCurrentPagePayload {
  currentPage: number;
}

export function setCurrentPage(
  currentPage: number,
): Action<GraphQueryTemplatesActionType.SetCurrentPage, SetCurrentPagePayload> {
  return {
    payload: {
      currentPage,
    },
    type: GraphQueryTemplatesActionType.SetCurrentPage,
  };
}

export interface Filters extends BaseFilterParams {
  status?: GraphQueryTemplateStatus[];
}

interface SetFiltersPayload {
  filters: Filters;
}

export function setFilters(
  filters: Filters,
): Action<GraphQueryTemplatesActionType.SetFilters, SetFiltersPayload> {
  return {
    payload: {
      filters,
    },
    type: GraphQueryTemplatesActionType.SetFilters,
  };
}

interface SetPageSizePayload {
  pageSize: number;
}

export function setPageSize(
  pageSize: number,
): Action<GraphQueryTemplatesActionType.SetPageSize, SetPageSizePayload> {
  return {
    payload: {
      pageSize,
    },
    type: GraphQueryTemplatesActionType.SetPageSize,
  };
}

interface SetSortParamsPayload {
  sortParams: SortParams;
}

export function setSortParams(
  sortParams: SortParams,
): Action<GraphQueryTemplatesActionType.SetSortParams, SetSortParamsPayload> {
  return {
    payload: {
      sortParams,
    },
    type: GraphQueryTemplatesActionType.SetSortParams,
  };
}

interface SetGraphQueryTemplatesPayload {
  graphQueryTemplates: GraphQueryTemplate[];
}

export function setGraphQueryTemplates(
  graphQueryTemplates: GraphQueryTemplate[],
): Action<GraphQueryTemplatesActionType.SetGraphQueryTemplates, SetGraphQueryTemplatesPayload> {
  return {
    payload: {
      graphQueryTemplates,
    },
    type: GraphQueryTemplatesActionType.SetGraphQueryTemplates,
  };
}
